export const seo = {
  siteName: "小院咖啡",
  tagline: "自家新鮮烘焙咖啡豆",
  description:
    "提供新鮮烘焙的高品質咖啡豆，讓你在忙碌的工作時刻，或是悠閒的居家時光，都能輕鬆為自己準備一杯香醇咖啡，享受片刻的寧靜與愜意。",
  keywords: "咖啡, 咖啡豆, 手沖咖啡, 掛耳, 濾掛, 浸泡",
  ogImage: "/images/og-image.jpg",
};
